exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collection .collection-item.active {\r\n    background-color: #0288d1;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/cbs/palestrantes/palestrantes.component.css
// module id = ../../../../../src/app/cbs/palestrantes/palestrantes.component.css
// module chunks = main